/**
 * Date utility functions for timezone conversion and formatting
 */

import { format, parseISO } from 'date-fns';

/**
 * Convert UTC date to Beijing time (UTC+8) and format it
 * @param {string|Date} dateInput - UTC date string or Date object
 * @param {string} formatString - Format string for date-fns (default: 'yyyy-MM-dd HH:mm:ss')
 * @returns {string} Formatted date string in Beijing time
 */
export function formatBeijingTime(dateInput, formatString = 'yyyy-MM-dd HH:mm:ss') {
  if (!dateInput) return '-';

  try {
    // Parse the date (handles both ISO strings and Date objects)
    const date = typeof dateInput === 'string' ? parseISO(dateInput) : dateInput;

    // Add 8 hours to convert UTC to Beijing time (UTC+8)
    const beijingTime = new Date(date.getTime() + (8 * 60 * 60 * 1000));

    return format(beijingTime, formatString);
  } catch (error) {
    console.error('Error formatting Beijing time:', error, dateInput);
    return '-';
  }
}

/**
 * Format date for display (short format without seconds)
 * @param {string|Date} dateInput - UTC date string or Date object
 * @returns {string} Formatted date string in Beijing time (yyyy-MM-dd HH:mm)
 */
export function formatBeijingDate(dateInput) {
  return formatBeijingTime(dateInput, 'yyyy-MM-dd HH:mm');
}

/**
 * Format date for display (with seconds)
 * @param {string|Date} dateInput - UTC date string or Date object
 * @returns {string} Formatted date string in Beijing time (yyyy-MM-dd HH:mm:ss)
 */
export function formatBeijingDateTime(dateInput) {
  return formatBeijingTime(dateInput, 'yyyy-MM-dd HH:mm:ss');
}
